let currentAccessToken;
let currentAccessIsForMobile;
//const isMobile = Boolean(
//	window.location.pathname ? window.location.pathname.match(/^\/mobile/) : false
//);

export const loadLocalStorage = () => {
	try {
		const sessionSavedState = localStorage.getItem('sessionSavedState');
		if (sessionSavedState === null) {
			return undefined;
		}
		const parsed = JSON.parse(sessionSavedState);

		//- Old way we used to store auth
		if (parsed.user && parsed.user.accessToken) {
			parsed.auth = parsed.user;
			delete parsed.user;
		}
		return parsed;
	} catch (err) {
		console.warn('Problems loading sessionSavedState', err);
		return undefined;
	}
};

export const saveLocalStorage = (state) => {
	if (!state.auth) {
		return;
	}
	if (
		state.auth.accessToken === currentAccessToken &&
		state.auth.accessIsForMobile === currentAccessIsForMobile
	) {
		return;
	}
	currentAccessToken = state.auth.accessToken;
	currentAccessIsForMobile = state.auth.accessIsForMobile;

	// console.info('Saving to localStorage', state.auth);

	try {
		const sessionSavedState = JSON.stringify({
			auth: {
				accessToken: state.auth.accessToken,
				accessIsForMobile: state.auth.accessIsForMobile,
			},
		});
		localStorage.setItem('sessionSavedState', sessionSavedState);
	} catch (err) {
		console.warn('Failed to save sessionSavedState');
	}
};
